



































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import DxDropDownBox from "devextreme-vue/drop-down-box";
import {
  DxDataGrid,
  DxSelection,
  DxPaging,
  DxFilterRow,
  DxScrolling,
  DxSearchPanel,
} from "devextreme-vue/data-grid";
import { centros } from "@/shared/dtos/centros";
import centrosModule from "@/store/modules/centros-module";
import {
  utilsGeoLoc,
  PuntoGeografico,
  GoogleMapMarker,
} from "@/utils/utils-geoloc";

declare global {
  interface Window {
    google: any;
  }
}

interface CentroOrdenado extends centros {
  distancia: number;
  position: PuntoGeografico;
}

@Component({
  components: {
    DxDropDownBox,
    DxDataGrid,
    DxSelection,
    DxPaging,
    DxFilterRow,
    DxScrolling,
    DxSearchPanel,
  },
  filters: {
    truncate(value: string, length: number) {
      if (!value) return "";
      if (value.length <= length) return value;
      return value.substring(0, length) + "...";
    },
  },
})
export default class RoutePlannerHaversine extends Vue {
  // --- Configuración Mapa ---
  public mapCenter = { lat: 39.399548026808425, lng: -0.4157916279543559 };
  public zoom = 6.5;

  // --- Estado UI ---
  public valid = false;
  public loading = false;

  public mapTitle = "Resultados de Ordenamiento";
  public mapTitleInputValue = "";
  public editandoNombre = false;

  // --- Datos Entrada ---
  public startLocation: PuntoGeografico | null = null;
  public startLocationName = "";

  public selectedCentros: number[] = [];
  public selectedCentros_DropDown: any[] = [];
  public centrosOptions: centros[] = [];

  public sortDescending: boolean = false;

  // --- Resultados ---
  public centrosOrdenados: CentroOrdenado[] = [];
  public distanciaTotal = 0;

  // --- Mapa Objects ---
  public routePath: PuntoGeografico[] = [];
  public infoWindowOpened = false;
  public infoWindowPosition: PuntoGeografico | null = null;
  public infoWindowContent: any = {};
  public infoWindowOptions = {
    pixelOffset: {
      width: 0,
      height: -35,
    },
  };

  public snackbar = {
    show: false,
    text: "",
    color: "success",
  };

  // --- Computed ---
  get isValidToOrder() {
    // Basic check: start location + at least 1 center
    return this.startLocation && this.selectedCentros.length > 0;
  }

  // --- Lifecycle ---
  async mounted() {
    await this.cargarCentros();
  }

  // --- Métodos ---
  async cargarCentros() {
    try {
      this.loading = true;
      await centrosModule.getcentroses();
      this.centrosOptions = centrosModule.centroses;
    } catch (error) {
      console.error("Error al cargar centros:", error);
      this.mostrarSnackbar("Error al cargar los centros", "error");
    } finally {
      this.loading = false;
    }
  }

  setStartLocation(place: any) {
    if (place && place.geometry) {
      this.startLocation = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      };
      this.startLocationName = place.formatted_address || place.name;
      this.mapCenter = this.startLocation;
      this.zoom = 12;
    }
  }

  updateSelectedCentros(e: any) {
    this.selectedCentros = e.value || [];
  }

  selectionChanged(e: any) {
    this.selectedCentros_DropDown = e.selectedRowKeys;
    // Mapear objetos a IDs si es necesario
    this.selectedCentros = e.selectedRowKeys.map(
      (item: any) => item.id || item
    );
  }

  getDisplayText(): string {
    if (!this.selectedCentros || this.selectedCentros.length === 0) {
      return "Selecciona los centros...";
    }
    const selectedNames = this.centrosOptions
      .filter((c) => this.selectedCentros.includes(c.id))
      .map((c) => c.nombre)
      .join(", ");
    return (
      selectedNames || `Seleccionados: ${this.selectedCentros.length} centros`
    );
  }

  ordenarCentrosPorHaversine() {
    if (!this.startLocation || this.selectedCentros.length === 0) {
      this.mostrarSnackbar("Faltan datos para ordenar", "warning");
      return;
    }

    this.loading = true;

    try {
      // 1. Filtrar seleccionados
      const centrosSeleccionados = this.centrosOptions.filter((c) =>
        this.selectedCentros.includes(c.id)
      );

      // 2. Convertir a formato de mapa
      const marcadores: GoogleMapMarker[] = centrosSeleccionados.map(
        (centro) => ({
          position: {
            lat: parseFloat(String(centro.latitud).replace(",", ".")) || 0,
            lng: parseFloat(String(centro.longitud).replace(",", ".")) || 0,
          },
          nombre: centro.nombre,
          direccion: centro.direccion,
          id: centro.id,
          info: centro,
        })
      );

      // 3. Ordenar
      let ordenados = utilsGeoLoc.ordenarPorProximidad(
        marcadores,
        this.startLocation
      );

      if (this.sortDescending) {
        ordenados = ordenados.reverse();
      }

      // 4. Mapear resultado a CentroOrdenado
      this.centrosOrdenados = ordenados.map((item) => {
        const centroOriginal = centrosSeleccionados.find(
          (c) => c.id === item.id
        );
        if (!centroOriginal) throw new Error("Error interno de mapeo");

        return Object.assign(new centros(centroOriginal), {
          distancia: item.distancia,
          position: item.position,
        }) as CentroOrdenado;
      });

      // 5. Cálculos finales
      this.calcularDistanciaTotal();
      this.crearRutaPath();
      this.ajustarMapaBounds();

      this.mostrarSnackbar("Centros ordenados correctamente", "success");

      // Auto-nombre si está vacío
      if (this.mapTitle === "Resultados de Ordenamiento" || !this.mapTitle) {
        this.mapTitle = `Ruta desde ${this.startLocationName.split(",")[0]}`;
      }
    } catch (error) {
      console.error("Error al ordenar:", error);
      this.mostrarSnackbar("Ocurrió un error al ordenar", "error");
    } finally {
      this.loading = false;
    }
  }

  limpiarResultados() {
    this.centrosOrdenados = [];
    this.distanciaTotal = 0;
    this.routePath = [];
    this.mapTitle = "Resultados de Ordenamiento";
  }

  saveTitle() {
    if (this.mapTitleInputValue && this.mapTitleInputValue.trim() !== "") {
      this.mapTitle = this.mapTitleInputValue;
    }
    this.editandoNombre = false;
  }

  @Watch("editandoNombre")
  onEditChange(val: boolean) {
    if (val) {
      this.mapTitleInputValue = this.mapTitle;
    }
  }

  public abrirRutaEnGoogleMaps() {
    if (!this.startLocation || this.centrosOrdenados.length === 0) return;

    const origin = `${this.startLocation.lat},${this.startLocation.lng}`;
    const destination = `${
      this.centrosOrdenados[this.centrosOrdenados.length - 1].position.lat
    },${this.centrosOrdenados[this.centrosOrdenados.length - 1].position.lng}`;

    // Waypoints son todos menos el último
    const waypointsArr = this.centrosOrdenados.slice(0, -1);
    const waypoints = waypointsArr
      .map((c) => `${c.position.lat},${c.position.lng}`)
      .join("|");

    const url = `https://www.google.com/maps/dir/?api=1&origin=${origin}&destination=${destination}&waypoints=${waypoints}&travelmode=driving`;
    window.open(url, "_blank");
  }

  // --- Utilidades de cálculo ---
  calcularDistanciaTotal() {
    if (!this.startLocation || this.centrosOrdenados.length === 0) {
      this.distanciaTotal = 0;
      return;
    }
    let total = 0;
    let puntoActual = this.startLocation;
    for (const centro of this.centrosOrdenados) {
      total += utilsGeoLoc.calcularDistanciaHaversine(
        puntoActual,
        centro.position
      );
      puntoActual = centro.position;
    }
    this.distanciaTotal = total;
  }

  calcularDistanciaAlSiguiente(index: number): number {
    if (index >= this.centrosOrdenados.length - 1) return 0;

    const actual = this.centrosOrdenados[index];
    const siguiente = this.centrosOrdenados[index + 1];

    return utilsGeoLoc.calcularDistanciaHaversine(
      actual.position,
      siguiente.position
    );
  }

  crearRutaPath() {
    if (!this.startLocation || this.centrosOrdenados.length === 0) {
      this.routePath = [];
      return;
    }
    this.routePath = [
      this.startLocation,
      ...this.centrosOrdenados.map((c) => c.position),
    ];
  }

  ajustarMapaBounds() {
    this.$nextTick(() => {
      const mapRef = this.$refs.map as any;
      if (!mapRef || !mapRef.$mapObject) return;

      const bounds = new window.google.maps.LatLngBounds();
      if (this.startLocation) {
        bounds.extend(
          new window.google.maps.LatLng(
            this.startLocation.lat,
            this.startLocation.lng
          )
        );
      }
      this.centrosOrdenados.forEach((c) => {
        bounds.extend(
          new window.google.maps.LatLng(c.position.lat, c.position.lng)
        );
      });
      mapRef.$mapObject.fitBounds(bounds);
    });
  }

  // --- InfoWindow ---
  openInfoWindow(centro: CentroOrdenado) {
    this.infoWindowPosition = centro.position;
    this.infoWindowContent = centro;
    this.infoWindowOpened = true;
  }
  closeInfoWindow() {
    this.infoWindowOpened = false;
  }

  formatearDistancia(m: number) {
    return utilsGeoLoc.formatearDistancia(m);
  }

  mostrarSnackbar(text: string, color: string) {
    this.snackbar.text = text;
    this.snackbar.color = color;
    this.snackbar.show = true;
  }
}
